/**
 * Same convention as range `<option value>`: `${measurement_range}${unit}` from API.
 */
export function measurementUnitFromRangeValue(range: unknown): string | null {
  if (typeof range !== "string" || !range.trim()) return null;
  const m = range.match(/^-?\d*\.?\d+(.*)$/);
  const suffix = m?.[1]?.trim();
  return suffix && suffix.length > 0 ? suffix : null;
}

/** Categories whose measurement_range is one-sided magnitude of a bipolar span (e.g. 20 → ±20 mV). */
export function isBipolarRangeCategory(category?: string | null): boolean {
  return (category || "").toLowerCase().includes("resistive strain gauge");
}

/**
 * Display label for sensor measurement range.
 * Strain Gauge stores 20 in DB and shows as ±20 mV; option values stay numeric (`20mV`).
 */
export function formatMeasurementRangeLabel(
  range: number | string | null | undefined,
  unit?: string | null,
  category?: string | null,
  options?: { compact?: boolean }
): string {
  if (range === null || range === undefined || range === "") return "";
  const compact = options?.compact === true;
  const unitPart = unit
    ? compact
      ? String(unit)
      : ` ${unit}`
    : "";
  const prefix = isBipolarRangeCategory(category) ? "±" : "";
  return `${prefix}${range}${unitPart}`;
}

/**
 * Label / placeholder / step for pressure-like additional fields in Start Calibration.
 * Used by shared {@link SensorInfoForm} when `disableUntilRangeSelected` is set (any sensor schema).
 */
export function pressureUnitInputHints(
  unitFromRange: string | null,
  schemaFallbackUnit: string
): { unitLabel: string; placeholder: string; step: string } {
  const label = unitFromRange?.trim() || schemaFallbackUnit?.trim() || "MPa";
  const u = label.toLowerCase();
  if (u === "mpa") return { unitLabel: label, placeholder: "e.g., 0.100", step: "0.001" };
  if (u === "kpa") return { unitLabel: label, placeholder: "e.g., 101.325", step: "0.01" };
  return { unitLabel: label, placeholder: "e.g., 101.325", step: "0.01" };
}
